import BusinessPartnersIcon from './icons/business-partners';
import BuyingAFlatIcon from './icons/buying-a-flat';
import ManagingMyHomeIcon from './icons/managing-my-home';
import ParkingIcon from './icons/parking';
import RentingFlatIcon from './icons/renting-a-flat';
import ShopsOfficeIcon from './icons/shops-&-offices';

export const headerItems = [
  {
    name: "Buying a flat",
    icon: <BuyingAFlatIcon />,
    sections: [
      {
        header: "Section 1 1",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 1 2",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 1 3",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      }
    ],
  },
  {
    name: "Managing my home",
    icon: <ManagingMyHomeIcon />,
    sections: [
      {
        header: "Executive condominium",
        links: [
          {
            text: "Moving in checklist",
            url: "/"
          },
          {
            text: "Conditions after buying",
            url: "/"
          },
          {
            text: "Changing owners/occupiers",
            url: "/"
          },
          {
            text: "Renting out a flat/bedroom",
            url: "/"
          },
          {
            text: "Keeping pets",
            url: "/"
          },
          {
            text: "Fire insurance",
            url: "/"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "CPF rules & early repayment",
            url: "/"
          },
          {
            text: "Citizen top-up",
            url: "/"
          },
          {
            text: "Loan matters",
            url: "/"
          },
          {
            text: "Use of CPF for loan repayment",
            url: "/"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "Rectification work for new flats",
            url: "/"
          },
          {
            text: "Renovation",
            url: "/"
          },
          {
            text: "Home maintenance",
            url: "/"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "Upgrading & redevelopment",
            url: "/"
          },
          {
            text: "Enhancement for Active Seniors (EASE)",
            url: "/"
          },
          {
            text: "Enhancement for Active Seniors (EASE)",
            url: "/"
          },
          {
            text: "Wheelchair Lift Pilot Scheme",
            url: "/"
          },
          {
            text: "Neighbourhood Renewal Programme",
            url: "/"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "Overview of selling process",
            url: "/"
          },
          {
            text: "Eligibility to sell",
            url: "/"
          },
          {
            text: "Plan, source & contract",
            url: "/"
          },
          {
            text: "Resale application",
            url: "/"
          },
          {
            text: "Resale completion",
            url: "jacascript:void(0)"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "Retirement planning",
            url: "/"
          },
          {
            text: "Monetising your flat for retirement",
            url: "/"
          },
          {
            text: "Lease Buyback Scheme (LBS)",
            url: "/"
          },
          {
            text: "Lease Buyback Scheme (LBS)",
            url: "/"
          },
          {
            text: "Renting out your flat/bedroom",
            url: "/"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "Exploring my neighbourhood",
            url: "/"
          },
          {
            text: "Being a good neighbour",
            url: "/"
          },
          {
            text: "Celebrating LIFE in the heartlands",
            url: "/"
          }
        ]
      },
      {
        header: "Executive condominium",
        links: [
          {
            text: "View all e-Services",
            url: "/"
          },
        ]
      }
    ],
  },
  {
    name: "Renting a flat",
    icon: <RentingFlatIcon />,
    sections: [
      {
        header: "Section 3 1",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 3 2",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 3 3",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      }
    ],
  },
  {
    name: "Shops & offices",
    icon: <ShopsOfficeIcon />,
    sections: [
      {
        header: "Section 4 1",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 4 2",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 4 3",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      }
    ],
  },
  {
    name: "Business partners",
    icon: <BusinessPartnersIcon />,
    sections: [
      {
        header: "Section 5 1",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 5 2",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 5 3",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      }
    ],
  },
  {
    name: "Parking",
    icon: <ParkingIcon />,
    sections: [
      {
        header: "Section 6 1",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 6 2",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      },
      {
        header: "Section 6 3",
        links: [
          {
            text: "link 1",
            url: "/"
          },
          {
            text: "link 2",
            url: "/"
          },
          {
            text: "link 3",
            url: "/"
          }
        ]
      }
    ],
  },
  {
    name: "e-Services",
    url: "/",
  },
];

export const infoItems = [
  {
    name: "About us",
    sections: [
      {
        header: "Who we are",
        links: [
          {
            text: "Mission, vision, values / Our ethos",
            url: "/"
          },
          {
            text: "Our logo",
            url: "/"
          },
          {
            text: "Our growth",
            url: "/"
          },
          {
            text: "Meet the folks of HDB",
            url: "/"
          },
          {
            text: "Awards & accolades",
            url: "/"
          }
        ]
      },
      {
        header: "What we do",
        links: [
          {
            text: "Sustainable living / Sustainability",
            url: "/"
          },
          {
            text: "Research & innovation",
            url: "/"
          },
          {
            text: "Design for life",
            url: "/"
          },
          {
            text: "LIVINGSPACE",
            url: "/"
          }
        ]
      },
      {
        header: "Towns & estates",
        links: [
          {
            text: "Community spaces",
            url: "/"
          },
          {
            text: "HDB towns",
            url: "/"
          },
          {
            text: "New developments",
            url: "/"
          }
        ]
      },
      {
        header: "Work with us",
        links: [
          {
            text: "Careers",
            url: "/"
          },
          {
            text: "Scholarships & internships",
            url: "/"
          },
          {
            text: "Volunteering",
            url: "/"
          }
        ]
      },
      {
        header: "Ask HDB",
        links: [
          {
            text: "Contact us",
            url: "/"
          },
          {
            text: "#HDBSpeaks",
            url: "/"
          },
          {
            text: "Enquiries & feedback",
            url: "/"
          }
        ]
      }
    ]
  },
  {
    name: "HDB pulse",
    sections: [
      {
        header: "Press & media",
        links: [
          {
            text: "Press releases",
            url: "/"
          },
          {
            text: "News & updates",
            url: "/"
          },
          {
            text: "Letters to the media",
            url: "/"
          },
          {
            text: "New policies",
            url: "/"
          },
          {
            text: "For the media/press",
            url: "/"
          }
        ]
      },
      {
        header: "MyNiceHome",
        links: [
          {
            text: "MyNiceHome Portal",
            url: "/"
          }
        ]
      },
      {
        header: "Perspectives",
        links: [
          {
            text: "Expert Insights",
            url: "/"
          },
          {
            text: "Life Stories",
            url: "/"
          }
        ]
      },
      {
        header: "Reports",
        links: [
          {
            text: "Annual reports",
            url: "/"
          },
          {
            text: "Green finance reports",
            url: "/"
          },
          {
            text: "Credit rating",
            url: "/"
          },
          {
            text: "Financial statements",
            url: "/"
          }
        ]
      }
    ]
  }
];